import * as angular from "angular";
import {IController} from "angular";
import {TagModel} from "../../angular/models/tag.model";

export class TagsTableRowComponent implements IController {

  tag: TagModel;
  isShowOnDriverApp: boolean;
  isShowOnWorkforceApp: boolean;
  isShowOnConsole: boolean;
  canEdit: boolean;
  onEditTag: Function;
  onDeleteTag: Function;

  constructor() {
  }

  $onInit() {
  }


}

angular
  .module('bringoz.admin.tags')
  .component('tagsTableRow', {
    bindings: {
      isShowOnDriverApp: '<',
      isShowOnWorkforceApp: '<',
      isShowOnConsole: '<?',
      canEdit: '<',
      tag: '<',
      onEditTag: '&',
      onDeleteTag: '&'
    },
    template: require('./tags-table-row.html').default,
    controller: TagsTableRowComponent
  });
